export const customEvents = {
    BURGER_EV:{
        click: 'burger:clicked',
        close: 'burger:close'
    },
    MENU_EV:{
        close: 'mainmenu:close'
    },
    CHAT:{
        init: 'chat:init',
        destroyed: 'chat:destroyed',
        help_click: 'chat:help_click',
        minimized: 'chat:minimized',
        maximized: 'chat:maximized',
        availability: 'chat:availability',
        req_success: 'chat:req_success',
        agent_join: 'chat:agent_join',
        established: 'chat:established',
        endByUser: 'chat:user_ends',
        endByAgent: 'chat:agent_ends',
    }
};
